export const optionTitle_templates = "$Ccsnb";
export const optionSearchTerms_templates = "oHUgZb";
export default {optionTitle_templates,optionSearchTerms_templates};